module.exports = __webpack_public_path__ + "img/icon_umesr.dac21dc0.svg";